"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const helpers_1 = require("../../lib/helpers");
const useToggleableChange_1 = require("../../hooks/useToggleableChange");
const Input_1 = __importDefault(require("./Base/Input"));
const InputDiv_1 = __importDefault(require("./Base/InputDiv"));
const useInputForm_1 = require("../../hooks/useInputForm");
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const InputError_1 = __importDefault(require("./Base/InputError"));
const ToggleInput = (props) => {
    const { label, checked, checkedValue = true, name, uncheckedValue = false } = props;
    const value = useInputForm_1.useInputValue(props);
    const isChecked = checked !== undefined ? checked : helpers_1.isSameCheckedValue(value, checkedValue);
    const onChange = useInputForm_1.useInputFormChange(props);
    const toggleableProps = useToggleableChange_1.useToggleableChange(onChange, props.onClick, props.disabled);
    return (react_1.default.createElement(InputDiv_1.default, { value: props.value, className: classnames_1.default(props.className, { disabled: props.disabled }), label: props.label, name: props.name, error: props.error },
        react_1.default.createElement("div", Object.assign({ className: "j-toggle-input-wrap" }, toggleableProps),
            react_1.default.createElement("div", { className: classnames_1.default('j-toggle-input-switch', isChecked ? 'on' : 'off') },
                react_1.default.createElement(Input_1.default, Object.assign({}, helpers_1.without(props, ['className']), { type: "checkbox", checked: isChecked })),
                react_1.default.createElement("div", { className: "j-toggle-input-handle" })),
            label && react_1.default.createElement("span", { className: "j-toggle-input-label" }, label)),
        react_1.default.createElement(InputError_1.default, null)));
};
exports.default = withJourney_1.default('j-toggle-input', ToggleInput);
